export default __webpack_public_path__ + "static/media/megane-large.99c80bfb.jpg";